export default __webpack_public_path__ + "static/media/Logo.58169365.png";